import { Outlet } from "react-router-dom"
import { useTranslation } from "react-i18next";
import NavBar from './nav-bar/NavBar';

export default function Layout() {
  const { t } = useTranslation();

  const navigation = [
    { name: t("nav-menu-product"), href: "/product" },
    { name: t("nav-menu-features"), href: "/features" },
    { name: t("nav-menu-marketplace"), href: "/market-place" },
    { name: t("nav-menu-company"), href: "/comapny" },
  ];

  return (
    <div className="bg-white">
      <header className="absolute inset-x-0 top-0 z-50">
        <NavBar navigation={navigation}/>
      </header>
      <Outlet />
    </div>
  );
}
